const servers = [
    {
        name: "Exness-MT5Trial",
        url: "nl-algo.excalls.io/trial1",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Trial2",
        url: "nl-algo.excalls.io/trial2",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Trial3",
        url: "nl-algo.excalls.io/trial3",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Trial4",
        url: "nl-algo.excalls.io/trial4",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Trial11",
        url: "mi-algo.excalls.io/trial11",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Trial12",
        url: "mi-algo.excalls.io/trial12",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Trial14",
        url: "sg-algo.excalls.io/trial14",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Real23",
        url: "hk-algo.excalls.io/real23",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real5",
        url: "hk-algo.excalls.io/real5",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Trial5",
        url: "hk-algo.excalls.io/trial5",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Real10",
        url: "jb-algo.excalls.io/real10",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real21",
        url: "jb-algo.excalls.io/real21",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real9",
        url: "jb-algo.excalls.io/real9",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Trial10",
        url: "jb-algo.excalls.io/trial10",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Trial9",
        url: "jb-algo.excalls.io/trial9",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Real11",
        url: "mi-algo.excalls.io/real11",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real12",
        url: "mi-algo.excalls.io/real12",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real22",
        url: "mi-algo.excalls.io/real22",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real",
        url: "nl-algo.excalls.io/real1",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real14",
        url: "nl-algo.excalls.io/real14",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real19",
        url: "nl-algo.excalls.io/real19",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real2",
        url: "nl-algo.excalls.io/real2",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real3",
        url: "nl-algo.excalls.io/real3",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real4",
        url: "nl-algo.excalls.io/real4",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real15",
        url: "sg-algo.excalls.io/real15",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real16",
        url: "sg-algo.excalls.io/real16",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real17",
        url: "sg-algo.excalls.io/real17",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real18",
        url: "sg-algo.excalls.io/real18",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real20",
        url: "sg-algo.excalls.io/real20",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real24",
        url: "sg-algo.excalls.io/real24",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real6",
        url: "sg-algo.excalls.io/real6",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real7",
        url: "sg-algo.excalls.io/real7",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Real8",
        url: "sg-algo.excalls.io/real8",
        type: "LIVE"
    },
    {
        name: "Exness-MT5Trial6",
        url: "sg-algo.excalls.io/trial6",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Trial7",
        url: "sg-algo.excalls.io/trial7",
        type: "DEMO"
    },
    {
        name: "Exness-MT5Trial8",
        url: "sg-algo.excalls.io/trial8",
        type: "DEMO"
    },
    {
        name:"Exness-MT5Real31",
        url:"nl-algo.excalls.io/real31",
        type:"LIVE"
    }
    
]

export default servers;
